/* global globalThis */

function getCrypto() {
  if (typeof globalThis !== 'undefined' && globalThis.crypto) return globalThis.crypto
  if (typeof window !== 'undefined' && window.crypto) return window.crypto
  if (typeof self !== 'undefined' && self.crypto) return self.crypto
  return null
}

export function generateUuidV4() {
  const crypto = getCrypto()

  if (crypto && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
